import { i18n } from "@lingui/core";

const ENGLISH_CODE = "en";
const SPANISH_CODE = "es";
const FRENCH_CODE = "fr";
const PORTUGUESE_CODE = "pt";
const CHINESE_CODE = "zh";
const CHINESE_CODE_FULL = "zh-TW";
const GERMAN_CODE = "de";
const ITALIAN_CODE = "it";
const JAPANESE_CODE = "ja";
const TAGALOG_CODE = "tl";
const KOREAN_CODE = "ko";

const locales = {
  [ENGLISH_CODE]: "English",
  [SPANISH_CODE]: "Español",
  [FRENCH_CODE]: "Français",
  [PORTUGUESE_CODE]: "Português",
  [CHINESE_CODE]: "中文",
  [CHINESE_CODE_FULL]: "中文",
  [GERMAN_CODE]: "Deutsch",
  [ITALIAN_CODE]: "Italiano",
  [JAPANESE_CODE]: "日本語",
  [TAGALOG_CODE]: "Tagalog",
  [KOREAN_CODE]: "한국어",
};
// zh and zh-TW are the same.. zh-TW is the old code, but still used by the google translators.
// keep for the time being because AWP sends the code with -TW, and having here keeps things happy.

const defaultLocale = ENGLISH_CODE;

/**
 * We do a dynamic import of just the catalog that we need
 * @param locale any locale string
 */
async function dynamicActivate(locale, callback) {
  if (locale === "" || !locale) return;
  // validate locale code against our available set
  const languageCode = locales[locale] ? locale : defaultLocale;

  // import the translations locale file
  import(`@Src/locales/` + languageCode + `/messages.js`).then(({ messages }) => {
    i18n.load(languageCode, messages);
    i18n.activate(languageCode);
    if (callback) callback(true);
  });
}

export {
  ENGLISH_CODE,
  SPANISH_CODE,
  FRENCH_CODE,
  PORTUGUESE_CODE,
  CHINESE_CODE,
  CHINESE_CODE_FULL,
  GERMAN_CODE,
  ITALIAN_CODE,
  JAPANESE_CODE,
  TAGALOG_CODE,
  KOREAN_CODE,
  locales,
  defaultLocale,
  dynamicActivate,
};
